export default "__VITE_ASSET__BhPNu78b__"